export default __webpack_public_path__ + "static/media/556d95c6-2352-4272-9422-83d53f66cfa3.e5b59c47.ttf";